import type { Invitation } from "@/users/types";
import { apiClient } from "./apiClient";

export const invitationsGateway = {
  async listInvitations(): Promise<Array<Invitation>> {
    return await apiClient.get("/api/users/invitations");
  },

  async createInvitation(invitation: Invitation): Promise<Invitation> {
    return await apiClient.post("/api/users/invitations", invitation);
  },

  async deleteInvitation(invitation: Invitation): Promise<void> {
    return await apiClient.delete(`/api/users/invitations/${invitation.id}`);
  },
};
